import { useEffect, useContext, useCallback } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import RadioCard from "../Content/RadioCard";
// import HelperText from "../Content/HelperText";

import CalculatorContext from "../../Context/CalculatorContext";

import iconYes from "../../Images/static/icons/icon-yes.svg";
import iconNo from "../../Images/static/icons/icon-no.svg";

/* eslint-disable max-len */
function StepThreePage() {
  const { setCurrentStepIndex, isEmissionKnown, setIsEmissionKnown } =
    useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(2);
  }, [setCurrentStepIndex]);

  const onIsEmissionKnownChange = useCallback(
    (e) => {
      setIsEmissionKnown(e.target.value);
    },
    [setIsEmissionKnown],
  );

  return (
    <div className="tx-kalo form-steps-abwizard form-steps-abwizard-transparent">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h4 className="element-header text-center">
                  Ist Ihnen die{" "}
                  <span className="text-primary">
                    CO<sub>2</sub>-Emissionsmenge
                  </span>{" "}
                  für Ihre Liegenschaft bekannt?
                </h4>
              </StepsHeadline>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="row justify-content-center">
                              <div className="col-md-9 col-lg-8 text-center">
                                <fieldset className="form-group">
                                  <div className="form-group">
                                    <div className="form-group-custom-radio">
                                      <RadioCard
                                        id="is_emission_known_1"
                                        image={iconYes}
                                        label="Ja"
                                        value="1"
                                        checked={isEmissionKnown === "1"}
                                        onChange={onIsEmissionKnownChange}
                                      />
                                      <RadioCard
                                        id="is_emission_known_0"
                                        image={iconNo}
                                        label="Nein"
                                        value="0"
                                        checked={isEmissionKnown === "0"}
                                        onChange={onIsEmissionKnownChange}
                                      />
                                    </div>
                                  </div>
                                </fieldset>

                                <div className="form-group pt-4 pt-md-3">
                                  <input
                                    className="btn btn-secondary"
                                    type="submit"
                                    value="Weiter"
                                    disabled={isEmissionKnown === ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <HelperText>
                <p>
                  Sofern über 50% der angegebenen Quadratmeter gewerblich genutzt werden, wählen Sie
                  bitte „Ja“ aus.
                </p>
              </HelperText> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepThreePage;
